import api from './api';

export const callsService = {
  getCallLogs: async (params = {}) => {
    const response = await api.get('/calls/logs/', { params });
    return response.data;
  },

  initiateCall: async (phoneNumber, leadId) => {
    const response = await api.post('/calls/initiate/', {
      phone_number: phoneNumber,
      lead_id: leadId,
    });
    return response.data;
  },

  getScheduledCalls: async () => {
    const response = await api.get('/calls/scheduled/');
    return response.data;
  },

  createScheduledCall: async (callData) => {
    const response = await api.post('/calls/scheduled/', callData);
    return response.data;
  },

  getCallLogById: async (id) => {
    const response = await api.get(`/calls/logs/${id}/`);
    return response.data;
  },

  updateCallLog: async (id, callData) => {
    const response = await api.put(`/calls/logs/${id}/`, callData);
    return response.data;
  },

  deleteCallLog: async (id) => {
    await api.delete(`/calls/logs/${id}/`);
  },

  // Create call log for follow-up
  createCallLog: async (logData) => {
    const response = await api.post('/calls/logs/', logData);
    return response.data;
  },

  // Schedule a follow-up call
  scheduleFollowUpCall: async (callData) => {
    const response = await api.post('/calls/scheduled/', callData);
    return response.data;
  },

  // Get call logs for a specific lead
  getLeadCallLogs: async (leadId) => {
    const response = await api.get('/calls/logs/', { 
      params: { lead: leadId } 
    });
    return response.data;
  },

  // Get today's scheduled calls
  getTodaysScheduledCalls: async () => {
    const today = new Date().toISOString().split('T')[0];
    const response = await api.get('/calls/scheduled/', { 
      params: { date: today } 
    });
    return response.data;
  },

  // Get upcoming scheduled calls
  getUpcomingScheduledCalls: async () => {
    const response = await api.get('/calls/scheduled/', { 
      params: { upcoming: true } 
    });
    return response.data;
  },

  // Update scheduled call
  updateScheduledCall: async (id, callData) => {
    const response = await api.put(`/calls/scheduled/${id}/`, callData);
    return response.data;
  },

  // Delete scheduled call
  deleteScheduledCall: async (id) => {
    await api.delete(`/calls/scheduled/${id}/`);
  }
};

// Call types
export const CALL_TYPES = {
  INCOMING: 'incoming',
  OUTGOING: 'outgoing',
  MISSED: 'missed'
};

export const CALL_TYPE_LABELS = {
  [CALL_TYPES.INCOMING]: 'Incoming',
  [CALL_TYPES.OUTGOING]: 'Outgoing',
  [CALL_TYPES.MISSED]: 'Missed'
};

// Call statuses
export const CALL_STATUS = {
  SCHEDULED: 'scheduled',
  COMPLETED: 'completed',
  MISSED: 'missed',
  CANCELLED: 'cancelled'
};

export const CALL_STATUS_LABELS = {
  [CALL_STATUS.SCHEDULED]: 'Scheduled',
  [CALL_STATUS.COMPLETED]: 'Completed',
  [CALL_STATUS.MISSED]: 'Missed',
  [CALL_STATUS.CANCELLED]: 'Cancelled'
};

// Call purposes
export const CALL_PURPOSES = {
  FOLLOW_UP: 'follow_up',
  CONSULTATION: 'consultation',
  APPOINTMENT: 'appointment',
  RECOVERY_CHECK: 'recovery_check',
  INSURANCE: 'insurance',
  BILLING: 'billing',
  GENERAL: 'general'
};

export const CALL_PURPOSE_LABELS = {
  [CALL_PURPOSES.FOLLOW_UP]: 'Follow-up',
  [CALL_PURPOSES.CONSULTATION]: 'Consultation',
  [CALL_PURPOSES.APPOINTMENT]: 'Appointment',
  [CALL_PURPOSES.RECOVERY_CHECK]: 'Recovery Check',
  [CALL_PURPOSES.INSURANCE]: 'Insurance',
  [CALL_PURPOSES.BILLING]: 'Billing',
  [CALL_PURPOSES.GENERAL]: 'General'
};